// Offline fallback defaults for site content. At runtime the app fetches the
// live content from /api/content (see context/ContentContext.jsx); these values
// are used only until that loads or if the API is unreachable. They mirror
// functions/_lib/defaults.js on the backend.

export const DEFAULT_CONTENT = {
  company: {
    name: "Cancella Infissi",
    tagline: "Infissi, serramenti e cancelli su misura dal 1988",
    since: "1988",
    phone: "+39 333 179 3343",
    phoneHref: "+393331793343",
    whatsapp: "393331793343",
    email: "cancella.infissi@gmail.com",
    piva: "04536590757",
    address: "Via Firenze, 62 — 73020 Scorrano (LE)",
    facebook: "https://www.facebook.com/cancella.infissi/",
    instagram: "https://www.instagram.com/cancellainfissi/",
    hours: [
      { d: "Lunedì – Venerdì", h: "08:00–13:00 · 15:00–18:00" },
      { d: "Sabato", h: "08:30–13:00" },
      { d: "Domenica", h: "Chiuso" },
    ],
    logo: "https://customer-assets.emergentagent.com/job_8cc40d09-5df2-4337-b1d0-620cc7307299/artifacts/x540o4hh_Logo%20cancella%20infissi.jpg",
  },

  hero: {
    eyebrow: "Scorrano · Lecce",
    titleTop: "L'arte di chiudere",
    titleEmphasis: "e proteggere",
    titleEnd: "lo spazio",
    subtitle:
      "Costruiamo e installiamo infissi, serramenti e cancelli su misura in ferro, alluminio e PVC. Artigianalità italiana, precisione e design che durano nel tempo.",
    image:
      "https://images.unsplash.com/photo-1723639904174-f31d7aec160e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    ctaPrimary: "Richiedi un preventivo",
    ctaSecondary: "Guarda le lavorazioni",
  },

  about: {
    eyebrow: "Chi siamo",
    title: "Una storia di famiglia, forgiata nel ferro e nella luce.",
    image:
      "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    paragraph1:
      "Dal 1988 Cancella Infissi realizza e installa serramenti a Scorrano e in tutto il Salento. Uniamo la sapienza artigiana della lavorazione del ferro alla precisione delle moderne tecnologie dell'alluminio e del PVC, per dare a ogni casa infissi unici, sicuri ed eleganti.",
    paragraph2:
      "Ogni progetto nasce su misura: dal sopralluogo al disegno, dalla costruzione in officina al montaggio finale, seguiamo ogni dettaglio con la cura di chi firma il proprio lavoro.",
  },

  services: [
    { id: "alluminio", title: "Infissi in Alluminio", desc: "Serramenti a taglio termico, eleganti e resistenti, con un isolamento superiore e linee minimali.", img: "https://images.unsplash.com/photo-1563219125-43b8e31c0a24?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
    { id: "ferro", title: "Lavorazione del Ferro", desc: "Strutture in ferro battuto e acciaio realizzate e saldate a mano nella nostra officina.", img: "https://images.unsplash.com/photo-1598302936625-6075fbd98dd7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
    { id: "pvc", title: "Infissi in PVC", desc: "Soluzioni dal massimo isolamento termoacustico, durevoli e a bassa manutenzione.", img: "https://images.pexels.com/photos/5691472/pexels-photo-5691472.jpeg?auto=compress&cs=tinysrgb&w=1200" },
    { id: "cancelli", title: "Cancelli & Portoni", desc: "Cancelli carrabili e pedonali su misura, manuali o automatizzati, dal design sartoriale.", img: "https://images.pexels.com/photos/12225928/pexels-photo-12225928.jpeg?auto=compress&cs=tinysrgb&w=1200" },
    { id: "zanzariere", title: "Zanzariere", desc: "Zanzariere a rullo, plissé e scorrevoli, integrate con discrezione in ogni serramento.", img: "https://images.pexels.com/photos/9729590/pexels-photo-9729590.jpeg?auto=compress&cs=tinysrgb&w=1200" },
    { id: "tapparelle", title: "Tapparelle & Avvolgibili", desc: "Tapparelle in alluminio e PVC, motorizzazioni e riparazioni rapide e affidabili.", img: "https://images.unsplash.com/photo-1668451947822-1710f53bd0d5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
    { id: "porte", title: "Porte & Vetrate", desc: "Porte d'ingresso blindate e vetrate panoramiche che uniscono luce, sicurezza e stile.", img: "https://images.unsplash.com/photo-1600613363620-9fdf5cc9291b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  ],

  gallery: [
    { img: "https://images.unsplash.com/photo-1723639904174-f31d7aec160e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000", cap: "Vetrate panoramiche" },
    { img: "https://images.pexels.com/photos/12225928/pexels-photo-12225928.jpeg?auto=compress&cs=tinysrgb&w=1000", cap: "Cancello carrabile in ferro" },
    { img: "https://images.unsplash.com/photo-1563219125-43b8e31c0a24?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000", cap: "Facciata in alluminio" },
    { img: "https://images.unsplash.com/photo-1675747158954-4a32e28812c0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000", cap: "Portone sezionale" },
    { img: "https://images.unsplash.com/photo-1593501791050-39bc85a3321e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000", cap: "Finestra con tapparella" },
    { img: "https://images.unsplash.com/photo-1600613363620-9fdf5cc9291b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000", cap: "Serramento in legno-alluminio" },
    { img: "https://images.unsplash.com/photo-1525570665650-76bb26af503d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000", cap: "Porta scorrevole in alluminio" },
    { img: "https://images.pexels.com/photos/5691472/pexels-photo-5691472.jpeg?auto=compress&cs=tinysrgb&w=1000", cap: "Finestre in PVC" },
    { img: "https://images.unsplash.com/photo-1761347604632-944c4400093a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000", cap: "Ingresso con cancello" },
  ],

  stats: [
    { value: "1988", label: "Dal" },
    { value: "1500+", label: "Progetti realizzati" },
    { value: "3", label: "Materiali · Ferro, Alluminio, PVC" },
    { value: "5.0", label: "Valutazione Google" },
  ],
};

// Convenience aliases (used where a static default is fine).
export const COMPANY = DEFAULT_CONTENT.company;
export const SERVICES = DEFAULT_CONTENT.services;
export const GALLERY = DEFAULT_CONTENT.gallery;
export const STATS = DEFAULT_CONTENT.stats;

// Workshop videos — currently not editable from the admin, kept static.
export const PROCESS_VIDEOS = [
  {
    id: "infissi",
    label: "Lavorazione Infissi",
    title: "Dal profilo grezzo al serramento finito",
    desc: "Taglio, fresatura e assemblaggio dei profili: ogni infisso nasce calibrato al millimetro nella nostra officina.",
    src: "https://assets.mixkit.co/videos/32818/32818-720.mp4",
    poster: "https://assets.mixkit.co/videos/32818/32818-thumb-360-0.jpg",
  },
  {
    id: "cancelli",
    label: "Costruzione Cancelli",
    title: "Il ferro che prende forma",
    desc: "Saldatura, molatura e finitura: i nostri cancelli sono forgiati a mano, pezzo dopo pezzo.",
    src: "https://assets.mixkit.co/videos/47292/47292-720.mp4",
    poster: "https://assets.mixkit.co/videos/47292/47292-thumb-360-4.jpg",
  },
];
